
import { useState, useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import VillaFeatures from "@/components/VillaFeatures";
import HeroSection from "@/components/home/HeroSection";
import AboutSection from "@/components/home/AboutSection";
import FeaturedPhotos from "@/components/home/FeaturedPhotos";
import BookingSection from "@/components/home/BookingSection";
import NewsletterPopup from "@/components/NewsletterPopup";
import LanguageSelector from "@/components/LanguageSelector";
import { useLanguage } from "@/contexts/LanguageContext";
import { usePageTranslation } from "@/hooks/usePageTranslation";
import { PromoCTA } from "@/components/home/PromoCTA";

const HomePage = () => {
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const { language } = useLanguage();
  usePageTranslation('/');

  useEffect(() => {
    setIsPageLoaded(true);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Promo banner is now integrated inside Navbar */}
      <Navbar rightElement={<LanguageSelector />} />
      <main>
        <HeroSection isPageLoaded={isPageLoaded} />
        <PromoCTA />
        <AboutSection />
        <FeaturedPhotos />
        <VillaFeatures />
        <BookingSection />
      </main>
      <Footer />
      <NewsletterPopup />
    </div>
  );
};

export default HomePage;
